import { defineComponent as ee, h as d, watchEffect as oe, ref as te, provide as ce, toRef as ne, computed as B } from "vue";
import { useRtl as le } from "./highrise1067.mjs";
import re from "./highrise1243.mjs";
import se from "./highrise1244.mjs";
import { createInjectionKey as ae } from "./highrise529.mjs";
import { resolveWrappedSlot as R } from "./highrise1059.mjs";
import ie from "./highrise1081.mjs";
import { warnOnce as de } from "./highrise1064.mjs";
import he from "./highrise1053.mjs";
import P from "./highrise984.mjs";
import { createKey as n } from "./highrise314.mjs";
import { getMargin as ge } from "./highrise1080.mjs";
import { useThemeClass as Ce } from "./highrise1062.mjs";
import { color2Class as y } from "./highrise1076.mjs";
import fe from "./highrise1044.mjs";
import { call as ue } from "./highrise1077.mjs";
const be = Object.assign(Object.assign(Object.assign({}, P.props), re), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  // private
  internalCloseFocusable: {
    type: Boolean,
    default: !0
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onCheckedChange: Function
}), me = ae("n-tag"), Fe = ee({
  name: "Tag",
  props: be,
  slots: Object,
  setup(t) {
    process.env.NODE_ENV !== "production" && oe(() => {
      t.onCheckedChange !== void 0 && de("tag", "`on-checked-change` is deprecated, please use `on-update:checked` instead");
    });
    const s = te(null), {
      mergedBorderedRef: o,
      mergedClsPrefixRef: h,
      inlineThemeDisabled: g,
      mergedRtlRef: p
    } = he(t), f = P("Tag", "-tag", se, fe, t, h);
    ce(me, {
      roundRef: ne(t, "round")
    });
    function C() {
      if (!t.disabled && t.checkable) {
        const {
          checked: e,
          onCheckedChange: c,
          onUpdateChecked: i,
          "onUpdate:checked": r
        } = t;
        i && i(!e), r && r(!e), c && c(!e);
      }
    }
    function u(e) {
      if (t.triggerClickOnClose || e.stopPropagation(), !t.disabled) {
        const {
          onClose: c
        } = t;
        c && ue(c, e);
      }
    }
    const b = {
      setTextContent(e) {
        const {
          value: c
        } = s;
        c && (c.textContent = e);
      }
    }, m = le("Tag", p, h), l = B(() => {
      const {
        type: e,
        size: c,
        color: {
          color: i,
          textColor: r
        } = {}
      } = t, {
        common: {
          cubicBezierEaseInOut: k
        },
        self: {
          padding: z,
          closeMargin: _,
          borderRadius: I,
          opacityDisabled: T,
          textColorCheckable: O,
          textColorHoverCheckable: M,
          textColorPressedCheckable: j,
          textColorChecked: F,
          colorCheckable: H,
          colorHoverCheckable: S,
          colorPressedCheckable: E,
          colorChecked: N,
          colorCheckedHover: U,
          colorCheckedPressed: D,
          closeBorderRadius: V,
          fontWeightStrong: w,
          [n("colorBordered", e)]: K,
          [n("closeSize", c)]: W,
          [n("closeIconSize", c)]: A,
          [n("fontSize", c)]: L,
          [n("height", c)]: x,
          [n("color", e)]: q,
          [n("textColor", e)]: G,
          [n("border", e)]: J,
          [n("closeIconColor", e)]: $,
          [n("closeIconColorHover", e)]: Q,
          [n("closeIconColorPressed", e)]: X,
          [n("closeColorHover", e)]: Y,
          [n("closeColorPressed", e)]: Z
        }
      } = f.value, v = ge(_);
      return {
        "--n-font-weight-strong": w,
        "--n-avatar-size-override": `calc(${x} - 8px)`,
        "--n-bezier": k,
        "--n-border-radius": I,
        "--n-border": J,
        "--n-close-icon-size": A,
        "--n-close-color-pressed": Z,
        "--n-close-color-hover": Y,
        "--n-close-border-radius": V,
        "--n-close-icon-color": $,
        "--n-close-icon-color-hover": Q,
        "--n-close-icon-color-pressed": X,
        "--n-close-icon-color-disabled": $,
        "--n-close-margin-top": v.top,
        "--n-close-margin-right": v.right,
        "--n-close-margin-bottom": v.bottom,
        "--n-close-margin-left": v.left,
        "--n-close-size": W,
        "--n-color": i || (o.value ? K : q),
        "--n-color-checkable": H,
        "--n-color-checked": N,
        "--n-color-checked-hover": U,
        "--n-color-checked-pressed": D,
        "--n-color-hover-checkable": S,
        "--n-color-pressed-checkable": E,
        "--n-font-size": L,
        "--n-height": x,
        "--n-opacity-disabled": T,
        "--n-padding": z,
        "--n-text-color": r || G,
        "--n-text-color-checkable": O,
        "--n-text-color-checked": F,
        "--n-text-color-hover-checkable": M,
        "--n-text-color-pressed-checkable": j
      };
    }), a = g ? Ce("tag", B(() => {
      let e = "";
      const {
        type: c,
        size: i,
        color: {
          color: r,
          textColor: k
        } = {}
      } = t;
      return e += c[0], e += i[0], r && (e += `a${y(r)}`), k && (e += `b${y(k)}`), o.value && (e += "c"), e;
    }), l, t) : void 0;
    return Object.assign(Object.assign({}, b), {
      rtlEnabled: m,
      mergedClsPrefix: h,
      contentRef: s,
      mergedBordered: o,
      handleClick: C,
      handleCloseClick: u,
      cssVars: g ? void 0 : l,
      themeClass: a == null ? void 0 : a.themeClass,
      onRender: a == null ? void 0 : a.onRender
    });
  },
  render() {
    var t, s;
    const {
      mergedClsPrefix: o,
      rtlEnabled: h,
      closable: g,
      color: {
        borderColor: p
      } = {},
      round: f,
      onRender: C,
      $slots: u
    } = this;
    C == null || C();
    const b = R(u.avatar, (l) => l && d("div", {
      class: `${o}-tag__avatar`
    }, l)), m = R(u.icon, (l) => l && d("div", {
      class: `${o}-tag__icon`
    }, l));
    return d("div", {
      class: [`${o}-tag`, this.themeClass, {
        [`${o}-tag--rtl`]: h,
        [`${o}-tag--strong`]: this.strong,
        [`${o}-tag--disabled`]: this.disabled,
        [`${o}-tag--checkable`]: this.checkable,
        [`${o}-tag--checked`]: this.checkable && this.checked,
        [`${o}-tag--round`]: f,
        [`${o}-tag--avatar`]: b,
        [`${o}-tag--icon`]: m,
        [`${o}-tag--closable`]: g
      }],
      style: this.cssVars,
      onClick: this.handleClick,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, m || b, d("span", {
      class: `${o}-tag__content`,
      ref: "contentRef"
    }, (s = (t = this.$slots).default) === null || s === void 0 ? void 0 : s.call(t)), !this.checkable && g ? d(ie, {
      clsPrefix: o,
      class: `${o}-tag__close`,
      disabled: this.disabled,
      onClick: this.handleCloseClick,
      focusable: this.internalCloseFocusable,
      round: f,
      isButtonTag: this.internalCloseIsButtonTag,
      absolute: !0
    }) : null, !this.checkable && this.mergedBordered ? d("div", {
      class: `${o}-tag__border`,
      style: {
        borderColor: p
      }
    }) : null);
  }
});
export {
  Fe as default,
  me as tagInjectionKey,
  be as tagProps
};
